import { SVGProps } from 'react'

const Logo = (props: SVGProps<SVGSVGElement>) => {
  return <div>Yachthandel24.de ⛵ Administration</div>
}

export default Logo
